import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-page-deleted',
  templateUrl: './page-deleted.component.html',
  styleUrl: './page-deleted.component.scss',
  imports: [Button, RouterLink, Card, QuicklinkDirective],
})
export class PageDeleted {
  @Input() redirectUrl: string = '/';
  @Input() redirectLabel: string = 'Go to Dashboard';
}
